import React from 'react'
import { PureQueryOptions } from 'apollo-client'
import { VulnerabilitySeverityChangeModal } from './change-modal'
import { VulnerabilitySeverityDropdown } from './dropdown'
import { Severity } from '../vulnerability-severity'

interface Props {
  readonly organizationID: string
  readonly vulnerabilityID: string
  readonly severity: Severity
  readonly defaultSeverity: Severity
  readonly refetchQueries: PureQueryOptions[]
  readonly refresh: () => Promise<any>
}

interface State {
  readonly isDialogOpen: boolean
  readonly newSeverity?: Severity
}

export class VulnerabilitySeverityChangeDropdown extends React.Component<
  Props,
  State
> {
  public state: State = {
    isDialogOpen: false
  }

  public render() {
    const {
      organizationID,
      vulnerabilityID,
      severity,
      defaultSeverity,
      refetchQueries,
      refresh
    } = this.props
    const { isDialogOpen, newSeverity } = this.state

    return (
      <div data-testid="severity-dropdown-test-id">
        <VulnerabilitySeverityDropdown
          selectedSeverity={severity}
          defaultSeverity={defaultSeverity}
          onChange={this.onSeveritySelectionChange}
        />
        {newSeverity && (
          <VulnerabilitySeverityChangeModal
            isOpen={isDialogOpen}
            onClose={this.onDialogClose}
            organizationID={organizationID}
            vulnerabilityID={vulnerabilityID}
            refetchQueries={refetchQueries}
            refresh={refresh}
            severity={newSeverity}
          />
        )}
      </div>
    )
  }

  private onSeveritySelectionChange = (severity: Severity) => {
    if (this.props.severity !== severity) {
      this.setState({
        isDialogOpen: true,
        newSeverity: severity
      })
    }
  }

  private onDialogClose = () => {
    this.setState({
      isDialogOpen: false
    })
  }
}
